import React from 'react';

import { MDText } from 'i18n-react';

import { Button } from '@motorway/mw-highway-code';
import { Hyperlink } from '@motorway/mw-highway-code/alpha';

import { VERIFICATION_ANALYTICS_EVENTS } from 'Utilities/analytics/analyticsDocumentVerification';

import { Modal } from 'Storybook/components/local/Modal/Modal';

import LocalTexts from './HowVerificationWorksModal.texts.json';

import styles from './HowVerifiicationWorksModal.scss';

const LocalT = new MDText(LocalTexts);

export const HowVerificationWorksModal: React.FC = () => {
  const [isOpenModal, setIsOpenModal] = React.useState(false);

  const onModalClose = () => {
    setIsOpenModal(false);
    VERIFICATION_ANALYTICS_EVENTS.HOW_VERIFICATION_WORKS_CLICK();
  };

  const modalProps = { className: styles.container, contentClass: styles.modalContent, dialogClass: styles.modal, dismissModal: onModalClose, size: 'small' };

  return <>
    <div className={styles.modalTrigger}>
      <Hyperlink href="#" label={LocalT.translate('verificationModalTrigger')} onClick={(e) => {
        e.preventDefault();

        setIsOpenModal(true);
        VERIFICATION_ANALYTICS_EVENTS.HOW_VERIFICATION_WORKS_MODAL_OPEN();
      }} />
    </div>

    {isOpenModal && <Modal {...modalProps}>
      <h3 className={styles.heading}>{LocalT.translate('verificationModalTitle')}</h3>
      <div className={styles.content}>
        <p>{LocalT.translate('verificationModalContent1')}</p>
        <p>{LocalT.translate('verificationModalContent2')}</p>
        <p>{LocalT.translate('verificationModalContent3')}</p>
      </div>
      <div className={styles.buttonContainer}>
        <Button fullWidth label={LocalT.translate('verificationModalConfirm')} onClick={onModalClose} />
      </div>
    </Modal>}
  </>;
};
